import { ListResult } from '../../ts/fetchers/ListResult';
import { PermissionsHelper } from '../../ts/helpers/PermissionsHelper';
import { PermissionsMerger } from '../../ts/helpers/PermissionsMerger';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { IGranteePermissions } from '../../ts/models/IGranteePermissions';
import { IGetExplicitPermissionsResult } from '../../ts/ServerApi/requests/GetExplicitPermissionsRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ITypedIdWithName } from '../../ts/ServerApi/types/ITypedId';
import { ITypedIds } from '../../ts/ServerApi/types/ITypedIds';
import WebHttpClient from '../../httpClient/WebHttpClient';

export interface ExplicitPermissionsResult extends IResult {
  permissionsList: ListResult<IGranteePermissions>;
  sourceAuthorizablesById: _.Dictionary<ITypedIdWithName>;
}

export function getExplicitPermissionsForAuthorizables(
  authorizables: ITypedIds
): Promise<ExplicitPermissionsResult> {
  const requests = PermissionsHelper.explicitPermissionsRequestsForAuthorizables(authorizables);
  const combineResultsFn = (results: IGetExplicitPermissionsResult[]) => {
    return {
      permissions: ResultHelper.combine(results, (result) => result.permissions),
      groups: ResultHelper.combine(results, (result) => result.groups),
      users: ResultHelper.combine(results, (result) => result.users),
      sourceAuthorizableById: ResultHelper.combineByKey(results, (result) => result.sourceAuthorizableById),
      errors: ResultHelper.combineErrors(results)
    };
  };

  return WebHttpClient.sendRequestsParallel(requests, combineResultsFn)
    .then<ExplicitPermissionsResult>((result: IGetExplicitPermissionsResult) => {
      const list = PermissionsMerger.makeGranteePermissionsList(
        result.permissions, authorizables.ids, result.groups, result.users
      );
      return {
        permissionsList: new ListResult<IGranteePermissions>(list),
        sourceAuthorizablesById: result.sourceAuthorizableById,
        errors: result.errors
      };
  });
}

export function setExplicitPermissionsForAuthorizables(
  authorizables: ITypedIds,
  granteePermissions: IGranteePermissions,
): Promise<IResult> {
  const requests = PermissionsHelper.setExplicitPermissionsRequestsForAuthorizables(authorizables, granteePermissions);

  return WebHttpClient.sendRequestsParallel(requests, ResultHelper.combineResults);
}
